import { GetPrivacySettingsResponse } from '@fullstory/proto/fs/services/ingestion-settings';
import {
  SummaryResponse,
  GetAllInTimeRangeResponse,
  GetDetectionEventRecordResponse,
} from '@fullstory/proto/fs/services/dataloss';
import { combineReducers } from 'redux';
import { createLoadingReducer, createRequestReducer } from '@fullstory/redux-util';
import { DatalossRequestTypes } from './types';

const detectionEventRecords = createRequestReducer<GetAllInTimeRangeResponse>()(
  DatalossRequestTypes.GetDetectionEventRecordsInTimeRangeRequest,
  DatalossRequestTypes.GetDetectionEventRecordsInTimeRangeSuccess,
  DatalossRequestTypes.GetDetectionEventRecordsInTimeRangeFailure,
);

const detectionEventRecord = createRequestReducer<GetDetectionEventRecordResponse>()(
  DatalossRequestTypes.GetDetectionEventRecordRequest,
  DatalossRequestTypes.GetDetectionEventRecordSuccess,
  DatalossRequestTypes.GetDetectionEventRecordFailure,
);

const detectionEventRecordLoading = createLoadingReducer(
  DatalossRequestTypes.GetDetectionEventRecordRequest,
  DatalossRequestTypes.GetDetectionEventRecordSuccess,
  DatalossRequestTypes.GetDetectionEventRecordFailure,
);

const detectionEventRecordsLoading = createLoadingReducer(
  DatalossRequestTypes.GetDetectionEventRecordsInTimeRangeRequest,
  DatalossRequestTypes.GetDetectionEventRecordsInTimeRangeSuccess,
  DatalossRequestTypes.GetDetectionEventRecordsInTimeRangeFailure,
);

const datalossIncidents = createRequestReducer<SummaryResponse>()(
  DatalossRequestTypes.FetchAllIncidentsRequest,
  DatalossRequestTypes.FetchAllIncidentsSuccess,
  DatalossRequestTypes.FetchAllIncidentsFailure,
);

const datalossIncidentsLoading = createLoadingReducer(
  DatalossRequestTypes.FetchAllDatalossIgnoresRequest,
  DatalossRequestTypes.FetchAllDatalossIgnoresSuccess,
  DatalossRequestTypes.FetchAllDatalossIgnoresFailure,
);

const datalossIgnores = createRequestReducer<GetPrivacySettingsResponse>()(
  DatalossRequestTypes.FetchAllDatalossIgnoresRequest,
  DatalossRequestTypes.FetchAllDatalossIgnoresSuccess,
  DatalossRequestTypes.FetchAllDatalossIgnoresFailure,
);

const datalossIgnoresLoading = createLoadingReducer(
  DatalossRequestTypes.FetchAllDatalossIgnoresRequest,
  DatalossRequestTypes.FetchAllDatalossIgnoresSuccess,
  DatalossRequestTypes.FetchAllDatalossIgnoresFailure,
);

type DatalossReducerState = {
  detectionEventRecords: ReturnType<typeof detectionEventRecords>;
  detectionEventRecordsLoading: ReturnType<typeof detectionEventRecordsLoading>;
  detectionEventRecord: ReturnType<typeof detectionEventRecord>;
  detectionEventRecordLoading: ReturnType<typeof detectionEventRecordLoading>;
  datalossIncidents: ReturnType<typeof datalossIncidents>;
  datalossIncidentsLoading: ReturnType<typeof datalossIncidentsLoading>;
  datalossIgnores: ReturnType<typeof datalossIgnores>;
  datalossIgnoresLoading: ReturnType<typeof datalossIgnoresLoading>;
};

export const datalossReducer = combineReducers<DatalossReducerState>({
  detectionEventRecords,
  detectionEventRecordsLoading,
  detectionEventRecord,
  detectionEventRecordLoading,
  datalossIncidents,
  datalossIncidentsLoading,
  datalossIgnores,
  datalossIgnoresLoading,
});
